// extracted by mini-css-extract-plugin
export var md = "_2b-4";
export var semantic = "_2b-5";
export var sm = "_2b-3";
export var text = "_2b-6";
export var toggleInput = "_2b-0";
export var toggleSwitch = "_2b-1";
export var xs = "_2b-2";